import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRightIcon } from '@icons';
import React from 'react';
import { Button } from '../button/button';
import styles from './transfer.module.scss';
const TransferControlColumn = ({ onTransfer, disableTransferLeft, disableTransferRight, size, }) => {
    return (_jsxs("section", { className: styles.control_column, children: [_jsx(Button, { type: "icon", size: size, onClick: () => onTransfer('right'), disabled: disableTransferRight, children: _jsx(ChevronRightIcon, {}) }), _jsx(Button, { type: "icon", size: size, onClick: () => onTransfer('left'), disabled: disableTransferLeft, style: { transform: 'rotate(180deg)' }, children: _jsx(ChevronRightIcon, {}) })] }));
};
TransferControlColumn.displayName = 'TransferControlColumn';
export { TransferControlColumn };
